@if (trailingIcon().externalUrl) {
	<!-- ara-info-badge ist ein Badge (BETA/ALPHA/SOON), kein Textlink; die Pille bringt ihre eigene Optik mit. -->
	<a
		class="inline-flex h-full items-center justify-center whitespace-nowrap text-[0.625rem] font-medium leading-none no-underline select-none transition-all duration-150 ease-in-out cursor-pointer"
		[ngClass]="['badge-link', 'variant-' + effectiveVariant(), isSingleChar() ? 'badge-circle' : 'badge-pill']"
		[href]="trailingIcon().externalUrl"
		target="_blank"
		rel="noopener noreferrer"
		[araAdaptiveTooltip]="[trailingIcon().title, trailingIcon().text].filter(Boolean).join('\n\n')"
		matTooltipClass="multiline-tooltip"
		[matTooltipPosition]="tooltipPosition()"
		(click)="$event.stopPropagation()">
		{{ displayLabel() }}
	</a>
} @else {
	<span
		class="inline-flex h-full items-center justify-center whitespace-nowrap text-[0.625rem] font-medium leading-none no-underline select-none transition-all duration-150 ease-in-out cursor-default"
		[ngClass]="['badge-static', 'variant-' + effectiveVariant(), isSingleChar() ? 'badge-circle' : 'badge-pill']"
		[araAdaptiveTooltip]="[trailingIcon().title, trailingIcon().text].filter(Boolean).join('\n\n')"
		matTooltipClass="multiline-tooltip"
		[matTooltipPosition]="tooltipPosition()">
		{{ displayLabel() }}
	</span>
}
